const Home = () => import('./../views/Home.vue')

export default [
  { name: 'home', path: '/', component: Home }
]
